import type { AuditEventType } from '../../shell/audit/auditLogs';

export { isImpersonationLogoutReason } from '../../shell/audit/auditVisibility';

export function resolveLogoutAuditEvent(reason?: string): AuditEventType {
  if (reason === 'timeout') return 'logout.timeout';
  if (reason === 'password_recovery_abandoned') return 'logout.password_recovery_dismissed';
  return 'logout.manual';
}
